var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('autocomplete',_vm._b({ref:"autocomplete",attrs:{"base-class":_vm.baseClass},on:{"submit":_vm.handleSubmit,"input":_vm.handleInput}},'autocomplete',Object.assign({}, _vm.$props, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }